import { onDocumentReady } from '@theme/utilities';

onDocumentReady(function setWebCheckoutCartAttribute() {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { web_checkout: 'true' },
    }),
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error('Error:', err);
    });
});
